export const FETCH_SIGNING_REQUESTS = "/document/signing-details/:envelopeId";
